import { useState } from "react";
import { Outlet, useOutletContext } from "react-router-dom";
import SubNav from "Components/Navbar/SubNav/SubNav";

interface Crumb {
  label: string;
  link?: string;
}

export interface OwnerOutletContext {
  setCrumbs: (crumbs: Crumb[]) => void;
}

export function useOwnerLayout() {
  return useOutletContext<OwnerOutletContext>();
}

export default function OwnerLayout() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const firstName: string = user?.firstName ?? "";
  const lastName: string = user?.lastName ?? "";
  const userName = `${firstName} ${lastName}`.trim() || "Owner";
  const userInitials =
    `${firstName[0] ?? ""}${lastName[0] ?? ""}`.toUpperCase() || "OW";

  const [crumbs, setCrumbs] = useState<Crumb[]>([]);

  return (
    <>
      <SubNav
        crumbs={crumbs}
        userName={userName}
        userInitials={userInitials}
        role="Owner / Borrower"
        crumbClass="crumbs"
        notifications={true}
        showSignout
      />
      <Outlet context={{ setCrumbs } satisfies OwnerOutletContext} />
    </>
  );
}
